$(document).ready(function () {
  /* MOBILE MENU TOGGLE */
  $(".menu-trigger").click(function () {
    $(this).toggleClass("menu-trigger--open");
    $(".c-menu").toggleClass("c-menu--open");
    $(document).find("body").toggleClass("u-no-scroll");

    if ($(".slick-dots").length > 0) {
      $(".slick-dots").toggleClass("slick-dots--menu-open");
    }
  });
});

$(document).ready(function () {
  /* SINGLE PAGE MOBILE MENU TOGGLE */
  $(".single-page-menu-trigger").click(function () {
    $(this).toggleClass("single-page-menu-trigger--open");
    $(".single-page-header__links").toggleClass(
      "single-page-header__links--open"
    );
    $(document).find("html").toggleClass("u-no-scroll");
  });

  $(document)
    .find(".header-menu-scroll__link")
    .click(function () {
      $(".single-page-menu-trigger").removeClass(
        "single-page-menu-trigger--open"
      );
      $(".single-page-header__links").removeClass(
        "single-page-header__links--open"
      );
      $(document).find("html").removeClass("u-no-scroll");
    });
});
